import APIFetcher from '../APIFetcher';

class DistrictLeaderApi {
  static createDistrictLeader(payload) {
    return APIFetcher.post('district-leader/', {payload});
  }

  static persistDistrictLeader(payload) {
    const url = `district-leader/${payload.id + '/' || ''}`;
    return APIFetcher.post(url, {payload});
  }
}

export default DistrictLeaderApi;
